export default __webpack_public_path__ + "static/media/Vehicle Management.9cf8d4a3.svg";